import React from 'react';
import { Phone, MessageCircle, MapPin } from 'lucide-react';

export default function TopContactBar() {
  return (
    <div className="bg-gray-900 text-white py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          {/* Contact Info */}
          <div className="flex items-center justify-center sm:justify-start space-x-4">
            <a
              href="tel:+918559929954"
              className="flex items-center text-sm hover:text-blue-400 transition-colors"
            >
              <Phone className="h-4 w-4 mr-1" />
              +91 8559929954
            </a>
            <a
              href="https://wa.me/918559940369"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-sm hover:text-green-400 transition-colors"
            >
              <MessageCircle className="h-4 w-4 mr-1" />
              +91 8559940369
            </a>
          </div>
          
          {/* Pan India Service */}
          <div className="flex items-center justify-center sm:justify-end text-sm text-gray-400">
            <MapPin className="h-4 w-4 mr-1" />
            <span>Servicing Pan India</span>
          </div>
        </div>
      </div>
    </div>
  );
}